export const convertVideoLinks = (htmlContent: string) => {
  const videoRegex = /assets\/blog_videos\/[^\s]+\.mp4/g;
  return htmlContent.replace(videoRegex, (match) => {
    return `<video width="100%" controls>
              <source src="${match}" type="video/mp4" />
              Votre navigateur ne supporte pas la balise vidéo.
            </video>`;
  });
};
